// eslint-disable-next-line
import React from 'react' // Needed for styled() Extends

import styled from 'styled-components'
import { Icon, CheckMark, Text } from 'components/Form/Styles'
const tabletWidth = 1024
export const ContactUs = styled.div`
  width: 100%;
  margin: 0 auto;
  display: flex;

  &[data-type='main'] {
    padding: 50px 0;
  }

  [data-section='contact-us'] {
    max-width: 1400px;
    width: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    align-items: flex-start;
    &[data-type='section'] {
      flex-direction: column;
      justify-content: center;
      align-items: center;
      [data-section='contact-us-text'] {
        margin: 50px auto 70px;
        text-align: center;
      }
    }
  }

  img {
    width: 50%;
    max-width: 600px;
    height: auto;
    @media (max-width: ${tabletWidth}px) {
      display: none;
    }
  }

  [data-type='contact-form'] {
    form {
      max-width: 740px;
      padding: 35px;
    }

    p {
      &[data-type='title'] {
        width: 95%;
        margin: 0 0 10px;
        font-size: 30px;
        line-height: 44px;
        text-align: center;

        @media (max-width: 600px) {
          max-width: 300px;
          font-size: 24px;
          line-height: 30px;
          text-align: center;
          margin: 0 auto 10px;
        }
      }
    }

    input {
      padding: 10px;
      font-size: 20px;
      margin: 10px 0;
      max-width: 100%;
      text-align: left;
    }

    label {
      font-size: 14px;
      margin: 30px 0 0 10px;
    }

    [data-type='input'] {
      width: 100%;
      margin: 0 0 5px;
      input {
        width: 100%;
        padding: 15px 10px 5px;
        font-size: 16px;
      }
      [data-type='error'] {
        bottom: -10px;
      }

      @media (max-width: 600px) {
        input {
          font-size: 13px;
          padding: 10px 8px 5px;
          margin: 0 0 10px 0;
          height: 40px;
        }
        label {
          font-size: 12px;
          margin: 15px 0 0 10px;
        }
        [data-type='error'] {
          bottom: -5px;
        }
      }
    }

    [data-type='nameRow'] {
      width: 100%;
      display: flex;
      justify-content: space-between;
      [data-type='input'] {
        width: 48%;
      }
    }

    [data-type='checkboxes'] {
      width: 100;
      display: flex;
      flex-wrap: wrap;
      [data-type='checkbox'] {
        width: 50%;
        margin: 0 0 20px;

        ${Icon} {
          width: 24px;
          height: 24px;
          padding-bottom: 4px;
          ${CheckMark} {
            width: 9px;
            height: 15px;
            border-width: 0 3px 3px 0;
          }
        }
        ${Text} {
          margin-left: 0;
          padding-left: 15px;
          font-size: 16px;
        }

        @media (max-width: 600px) {
          ${Icon} {
            width: 18px;
            height: 18px;
            padding-bottom: 4px;
            ${CheckMark} {
              width: 6px;
              height: 12px;
              border-width: 0 2px 2px 0;
            }
          }
          ${Text} {
            font-size: 13px;
          }
        }

        @media (max-width: 450px) {
          width: 100%;
          margin: 0 0 10px;
        }
      }
    }

    [data-type='button-recaptcha-container'] {
      display: flex;
      flex-direction: column;
      gap: 10px;
      @media (max-width: ${tabletWidth}px) {
        margin-bottom: 10px;
      }
    }

    button {
      width: 100%;
      margin-top: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 50px;
      border: solid 1px #ffffff;
      background-color: #333333;
      color: #ffffff;
      font-size: 20px;
      white-space: nowrap;
      padding: 0;
      opacity: 1;
      transition: 0.3s ease opacity;
      cursor: pointer;
      &[data-type='dark'] {
        border: solid 1px #333333;
        background-color: #ffffff;
        color: #333333;
        font-size: 14px;
        font-weight: bold;
      }
      &:hover {
        opacity: 0.7;
      }
      &:focus {
        outline: none;
      }
      &[disabled],
      &[disabled]:hover {
        opacity: 0.5;
        cursor: default;
      }
    }

    [data-type='confirm-contact'] {
      text-align: center;
    }

    [data-type='recaptcha'],
    [data-type='subscribe'] {
      display: flex;
      justify-content: flex-start;
      width: 100%;
      font-size: 11px;
      line-height: 1.1em;
      a {
        margin-left: 3px;
      }
    }
  }
`
export const StyleWrap = styled.div`
  display: block;
  position: relative;
  background: ${(props) => props.theme.colors.white};
  width: 1200px;
  height: 600px;
  color: ${(props) => props.theme.colors.default};
  &[data-type='contact'] {
    height: 706px;
    width: 100%;
    max-width: 1200px;

    [data-type='contact-form'] {
      align-self: center;
    }

    @media (max-width: ${tabletWidth}px) {
      background-color: #fff;
      height: auto;
    }
  }
  @media (max-width: ${tabletWidth}px) {
    width: 100%;
    height: auto;
    img {
      width: 50%;
      max-width: 600px;
      height: auto;
      @media (max-width: ${tabletWidth}px) {
        display: none;
      }
    }
  }
  > div:first-child {
    position: absolute;
    top: 10px;
    right: 10px;
    @media (max-width: ${tabletWidth}px) {
      @supports (-webkit-touch-callout: none) {
        /* CSS specific to iOS devices */
        top: 10px;
      }
    }
    svg {
      background: ${(props) => props.theme.colors.white};
      z-index: 10000;
      path {
        stroke: ${(props) => props.theme.colors.default};
        fill: ${(props) => props.theme.colors.white};
      }
      &:hover path {
        stroke: ${(props) => props.theme.colors.default};
      }
    }
  }
`
